import React from 'react';

import PropTypes from 'prop-types';
import { Dropdown } from 'semantic-ui-react';

import useSemanticUiProps from 'hooks/useSemanticUiProps';

import { TEMPLATE_TYPE_OPTIONS } from './ThemeTemplateTypeDropdown.constants';

import './ThemeTemplateTypeDropdown.scss';

const propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

const defaultProps = {};

function ThemeTemplateTypeDropdown({ value, onChange, ...rest }) {
  const { getDropdownProps } = useSemanticUiProps();

  return (
    <Dropdown
      selection
      clearable
      options={TEMPLATE_TYPE_OPTIONS}
      value={value}
      onChange={onChange}
      placeholder="Template Type"
      className="template-type-dropdown"
      {...getDropdownProps(rest)}
    />
  );
}

ThemeTemplateTypeDropdown.propTypes = propTypes;
ThemeTemplateTypeDropdown.defaultProps = defaultProps;

export default ThemeTemplateTypeDropdown;
